import {
  useCallback,
} from 'react'
import Select from 'react-select'
import { Form } from 'react-bootstrap'
import {
  useSearchParams,
} from 'react-router-dom'
import {
  filters,
  wayFilterCategories,
  signFilterCategories,
} from '../../filters'

function reactSelectToFilter(selected) {
  return selected.map((option) => option.value)
}

function filterToReactSelect(options, filter) {
  let selected = []
  if (Array.isArray(filter)) {
    selected = filter
  } else if (filter) {
    selected = [filter.toString()]
  }

  return options.filter((option) => selected.includes(option.value.toString()))
}

export function searchParamsToFilter(entries) {
  const result = {}
  for(const [key, value] of entries) {
    const filterConfig = filters[key]
    if (!filterConfig) {
      continue
    }
    if (filterConfig.type === 'multi-select') {
      if (!(key in result)) {
        result[key] = [value]
      } else {
        result[key].push(value)
      }
    } else {
      result[key] = value
    }
  }
  return result
}

function renderFilterControl(filter, filterId, setFilter) {
  const {
    type,
    label,
    disabledFun,
    options,
    data,
    resetFiltersOnChange,
  } = filters[filterId]

  const value = filter[filterId]

  const disabled = disabledFun ? disabledFun(filter) : false

  if (type === 'single-select') {
    return (
      <>
        <Form.Label>{ label }</Form.Label>
        <Form.Control
          as="select"
          disabled={disabled}
          onChange={(event) => {
            setFilter(filterId, event.target.value)

            const resetFilters = resetFiltersOnChange ? resetFiltersOnChange(event.target.value) : []

            resetFilters.forEach((otherFilterId) => setFilter(otherFilterId, null))
          }}
          value={value}
        >
          {
            options.map((option) => (
              <option
                key={`filter-option-${data}-${filterId}-${option.value || 'null'}`}
                value={option.value}
              >
                { option.label }
              </option>
            ))
          }
        </Form.Control>
      </>
    )
  }

  if (type === 'multi-select') {
    return (
      <>
        <Form.Label>{ label }</Form.Label>
        <Select
          isMulti
          isDisabled={disabled}
          options={options}
          value={filterToReactSelect(options, value)}
          placeholder="Alle"
          onChange={(value) => {
            setFilter(filterId, reactSelectToFilter(value))
            const resetFilters = resetFiltersOnChange ? resetFiltersOnChange(value) : []

            resetFilters.forEach((otherFilterId) => setFilter(otherFilterId, null))
          }}
        />
      </>
    )
  }

  if (type === 'boolean') {
    return (
      <Form.Check
        label={label}
        isDisabled={disabled}
        checked={value === 'true'}
        onChange={(event) => {
          setFilter(filterId, event.target.checked)

          const resetFilters = resetFiltersOnChange ? resetFiltersOnChange(event.target.value) : []
          resetFilters.forEach((otherFilterId) => setFilter(otherFilterId, null))
        }}
      />
    )
  }
}

function renderFilter(filter, filterId, setFilter) {
  return (
    <Form.Group
      key={filterId}
      style={{ marginBottom: '0.5rem' }}
    >
      {
        renderFilterControl(filter, filterId, setFilter)
      }
    </Form.Group>
  )
}


function FilterBar(props) {
  const [searchParams, setSearchParams] = useSearchParams()

  const filter = searchParamsToFilter(searchParams)

  const setFilter = useCallback((param, value) => {
    setSearchParams((prevParams) => {
      if (Array.isArray(value)) {
        prevParams.delete(param)

        value.forEach((val) => prevParams.append(param, val))
      } else {
        if ([undefined, null, '', false].includes(value)) {
          prevParams.delete(param)
        } else {
          prevParams.set(param, value)
        }
      }
      return prevParams
    })
  }, [
    setSearchParams,
  ])

  return (
    <Form>
      <section>
        <h4>Wege</h4>
        {
          Object.keys(wayFilterCategories).map((categoryId) => (
            <section key={categoryId} style={{ marginTop: '1em' }}>
              <h5>{ wayFilterCategories[categoryId].label }</h5>
              {
                Object.keys(filters)
                  .filter((filterId) => filters[filterId].data === 'ways')
                  .filter((filterId) => filters[filterId].category === categoryId)
                  .map((filterId) => renderFilter(filter, filterId, setFilter))
              }
            </section>
          ))
        }
      </section>
      <section style={{ marginTop: '2em' }}>
        <h4>Schilder</h4>
        {
          Object.keys(signFilterCategories).map((categoryId) => (
            <section key={categoryId} style={{ marginTop: '1em' }}>
              <h5>{ signFilterCategories[categoryId].label }</h5>
              {
                Object.keys(filters)
                  .filter((filterId) => filters[filterId].data === 'signs')
                  .filter((filterId) => filters[filterId].category === categoryId)
                  .map((filterId) => renderFilter(filter, filterId, setFilter))
              }
            </section>
          ))
        }
      </section>
    </Form>
  )
}

export default FilterBar
